import React, { useState } from 'react';
import { Link } from 'react-router-dom';

interface HeroSectionProps {
  title: string;
  subtitle: string;
  ctaText: string;
  ctaLink: string;
}

const HeroSection = ({ title, subtitle, ctaText, ctaLink }: HeroSectionProps) => {
  const [showModal, setShowModal] = useState(false);

  return (
    <section id="hero" className="relative h-screen w-full overflow-hidden bg-black">
      {/* Background Images Grid */}
      <div className="absolute inset-0 grid grid-cols-2">
        {/* First Background Image */}
        <div 
          className="relative bg-cover bg-center bg-no-repeat"
          style={{ 
            backgroundImage: `url('https://vipsuvs.com/wp-content/uploads/2025/01/IMG_6442-scaled-e1735791816505.jpg?w=800&q=75&fm=webp&auto=format,compress')`,
            backgroundSize: 'cover',
            backgroundPosition: 'center',
            backgroundColor: '#000000' // Fallback color
          }}
        >
          <div className="absolute inset-0 bg-black/60"></div>
        </div>
        
        {/* Second Background Image */}
        <div 
          className="relative bg-cover bg-center bg-no-repeat"
          style={{ 
            backgroundImage: `url('https://epicblackcarny.com/wp-content/uploads/2023/01/Chauffeur-Service.jpg?w=800&q=75&fm=webp&auto=format,compress')`,
            backgroundSize: 'cover',
            backgroundPosition: 'center',
            backgroundColor: '#000000' // Fallback color
          }}
        >
          <div className="absolute inset-0 bg-black/60"></div>
        </div>
      </div>
      
      {/* Hero Content */}
      <div className="absolute inset-0 flex items-center justify-center text-center">
        <div className="container mx-auto px-4">
          <div className="animate-fade-in" style={{ animationDelay: "0.3s", animationFillMode: "forwards" }}>
            <div className="mx-auto h-20 w-20 rounded-full border-2 border-gold flex items-center justify-center mb-6">
              <span className="font-cinzel text-gold text-3xl font-bold">T</span>
            </div>
            <h1 className="font-cinzel text-5xl md:text-6xl lg:text-7xl font-bold text-white mb-4">
              TiLimousine
            </h1>
            <p className="text-xl md:text-2xl text-white/90 font-light mb-6">
              {subtitle}
            </p>
            <h2 className="font-cinzel text-2xl md:text-3xl text-gold mb-10">
              Luxury in Motion
            </h2>
            <button 
              onClick={() => setShowModal(true)}
              className="bg-gold text-black px-8 py-3 rounded-full hover:bg-gold/80 transition-colors text-lg font-semibold"
            >
              {ctaText}
            </button>
          </div>
        </div>
      </div>
      
      {/* Scroll Indicator */}
      <div className="absolute bottom-8 left-0 right-0 flex justify-center animate-bounce">
        <svg className="w-6 h-6 text-gold" fill="none" stroke="currentColor" viewBox="0 0 24 24" xmlns="http://www.w3.org/2000/svg">
          <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M19 14l-7 7m0 0l-7-7m7 7V3" />
        </svg>
      </div>
      
      {/* Booking Modal */}
      {showModal && (
        <div 
          className="fixed inset-0 bg-black/80 flex items-center justify-center z-50"
          onClick={() => setShowModal(false)}
        >
          <div 
            className="bg-black border border-gold/20 rounded-lg p-8 max-w-md w-full mx-4 relative"
            onClick={e => e.stopPropagation()}
          >
            <h3 className="text-2xl font-cinzel text-gold mb-4">Book Your Ride</h3>
            <p className="text-white/80 mb-6">How would you like to book?</p>
            <div className="space-y-4">
              <a 
                href="mailto:contact@tilimousine.com?subject=TiLimousine%20Booking%20Request&body=Name%3A%20%0APhone%3A%20%0APickup%20Location%3A%20%0ADrop-off%20Location%3A%20%0ADate%20%26%20Time%3A%20%0AAirport%20Name%3A%20%0AFlight%20Number%3A%20%0ASpecial%20Requests%3A%20" 
                className="block w-full bg-gold text-black px-6 py-3 rounded-full hover:bg-gold/80 transition-colors text-center font-semibold"
              >
                Book by Email
              </a>
              <a 
                href="tel:+18573123332" 
                className="block w-full bg-gold text-black px-6 py-3 rounded-full hover:bg-gold/80 transition-colors text-center font-semibold"
              >
                Book by Phone
              </a>
            </div>
            <button 
              className="absolute top-4 right-4 text-white/60 hover:text-white text-2xl"
              onClick={() => setShowModal(false)}
            >
              ×
            </button>
          </div>
        </div>
      )}
    </section>
  );
};

export default HeroSection;

